const ProgressBar = ({ blocks, blockSubmissions, currentBlockIndex }) => {
  // Calculate progress percentage based on completed blocks
  const completedBlocks = blockSubmissions.filter(submission => submission.status === 'COMPLETED').length;
  const totalBlocks = blocks.length;
  const progressPercentage = totalBlocks > 0 ? (completedBlocks / totalBlocks) * 100 : 0;

  return (
    <div className='flex flex-col mb-3 w-full'>

      <div className='h-2 w-full bg-accent rounded-sm overflow-hidden'>
        <div
          className='h-full bg-primary transition-all duration-300 ease-in-out'

          style={{ width: `${progressPercentage}%` }}
        />
      </div>

      <div className='text-xs text-gray-500 mt-1 text-left'>
        {completedBlocks} of {totalBlocks} completed
      </div>
    </div>
  )
}

const PlainProgressBar = ({ blocks, blockSubmissions, className }) => {
  // Calculate progress percentage based on completed blocks
  const completedBlocks = blockSubmissions.filter(submission => submission.status === 'COMPLETED').length;
  const totalBlocks = blocks.length;
  const progressPercentage = totalBlocks > 0 ? (completedBlocks / totalBlocks) * 100 : 0;

  return (
    <div className={`h-2 w-full bg-gray-300 ${className || ''}`}>
      <div
        className='h-full bg-primary transition-all duration-300 ease-in-out'
        style={{ width: `${progressPercentage}%` }}
      />
    </div>
  )
}

export default ProgressBar
export { PlainProgressBar }
